import type { ReactNode } from 'react';

import {
  ProductFooter,
  ProductHeader,
  ProductHeaderFooterProvider,
  Surface,
} from '@storebrand-digital/pretzel';

import { CenteredLoadingIndicator } from '../../CenteredLoadingIndicator';
import { getInverseBackground } from '../getInverseBackground';
import { HeaderFooterGrid } from '../HeaderFooterGrid';
import type { HeaderFooterTheme } from '../types';
import { WebViewLayout } from '../WebViewLayout';

interface Props {
  children: ReactNode;
  theme: HeaderFooterTheme;
  isProd: boolean;
  isWebView: boolean;
  locale: 'no' | 'en';
  onError: (error: unknown) => void;
}

export function ProductVariant({
  children,
  theme,
  isProd,
  isWebView,
  locale,
  onError,
}: Props) {
  if (isWebView) {
    return (
      <WebViewLayout locale={locale} theme={theme}>
        {children}
      </WebViewLayout>
    );
  }

  const inverseBg = getInverseBackground(theme);

  return (
    <ProductHeaderFooterProvider
      environment={isProd ? 'production' : 'test'}
      loadingComponent={<CenteredLoadingIndicator isFixed delayMs={1_000} />}
      onError={onError}
    >
      <HeaderFooterGrid>
        <div>
          <ProductHeader />
        </div>

        <Surface
          isBackground
          lightThemeBackgroundLayer={theme}
          className="flex flex-col box-border"
        >
          {children}
        </Surface>

        <Surface isBackground lightThemeBackgroundLayer={inverseBg}>
          <ProductFooter />
        </Surface>
      </HeaderFooterGrid>
    </ProductHeaderFooterProvider>
  );
}
